<template>
  <a-layout>
    <a-space>
      <a-input v-model="query['item.no']" :addon-before="$t('business.label.itemNo')" :loading="loading" allowClear @pressEnter="search"/>
      <a-input-search v-model="query['item.name']" :addon-before="$t('business.label.itemName')" :loading="loading" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['location.no']" :addon-before="$t('business.label.locationNo')" :loading="loading" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['container.no']" :addon-before="$t('business.label.containerNo')" :loading="loading" @pressEnter="search" @search="search"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="batch.no" title="business.label.batchNo"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
      <vxe-column field="inventory.availableQuantity" title="business.label.availableQuantity"/>
      <vxe-column field="inventory.quantity" title="business.label.quantity"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="inventory.inventoryState" title="business.label.inventoryStatus"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import { findAll, findEnum } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'TemporaryInventoryTable',
  data() {
    return {
      loading: false,
      inventoryStates: [],
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': ''
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.77)
    }
  },
  created() {
    findEnum('InventoryState').then(res => {
      this.inventoryStates = res.result.map(item => {
        return { label: item.name, value: item.ordinal }
      })
    })
  },
  activated() {
    this.getData()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': ''
      }
      this.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('inventoryFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick(row) {
      this.$emit('dblclick', row)
    }
  }
}
</script>
